import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Button, Avatar, ToggleButton, ToggleButtonGroup } from "@mui/material";
import axios from "axios";
import BASE_API_URL from '../../apis/index';
import styled from "styled-components";
import AdminCompanySearchBar from "./components/AdminCompanySearchBar";
import { Link } from "react-router-dom";

const AdminCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [compStatus, setCompStatus] = useState("All"); // default
  const [totalPages, setTotalPages] = useState(1);
  const placeholderLogo = "/Images/user_profile_placeholder.png";

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const res = await axios.get(
          `${BASE_API_URL}/api/admin/companies?page=${page}&limit=${limit}&status=${compStatus}`,
          { headers: { Authorization: `Bearer ${authToken}` } }
        );

        setCompanies(res.data.companies);
        setTotalPages(res.data.totalPages);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, [page, limit, compStatus]); // re-fetch on status change

  useEffect(() => { setPage(1); }, [compStatus]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) setPage(newPage);
  };

  return (
    <Wrapper className='p-2'>
      <div className="mb-3 d-flex justify-content-between align-items-end">
        <div>
          <Typography variant="h5" mb={2}>User Companies</Typography>
          <ToggleButtonGroup
            value={compStatus}
            exclusive
            onChange={(e, newStatus) => newStatus && setCompStatus(newStatus)}
            size="small"
            className="StatusToggles"
          >
            <ToggleButton value="All">All</ToggleButton>
            <ToggleButton value="Pending">Pending</ToggleButton>
            <ToggleButton value="Approved">Approved</ToggleButton>
            <ToggleButton value="Rejected">Rejected</ToggleButton>
          </ToggleButtonGroup>
        </div>

        <AdminCompanySearchBar />
      </div>

      {/* Companies Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow className="bg-dark text-white">
              <TableCell><b className="text-white">Company Name</b></TableCell>
              <TableCell><b className="text-white">Company Type</b></TableCell>
              <TableCell><b className="text-white">Status</b></TableCell>
              <TableCell><b className="text-white">User Name</b></TableCell>
              <TableCell><b className="text-white">Created At</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companies.length > 0 ? (
              companies.map((company, index) => (
                <TableRow key={company.id}>
                  <TableCell className="compName">
                    <Link to={`/admin/company-details?compId=${company.id}`} className="text-decoration-none">
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Avatar
                          src={company.company_logo ? `${BASE_API_URL}/uploads/user_comp_docs/${company.company_logo}` : placeholderLogo}
                          alt={company.company_name}
                        />
                        <span>{company.company_name}</span>
                      </div>
                    </Link>
                  </TableCell>
                  <TableCell>{JSON.parse(company.company_types).join(", ")}</TableCell>
                  <TableCell>{company.status}</TableCell>
                  <TableCell>
                    <Link to={`/admin/user-details?userId=${company.user_id}`} target="_blank" className="text-decoration-none">
                      {company.user_name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {company.created_at
                      ? new Date(company.created_at).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">No companies found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box mt={2} display="flex" justifyContent="center" gap={1}>
        <Button variant="outlined" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
          Prev
        </Button>
        {[...Array(totalPages)].map((_, i) => (
          <Button
            key={i}
            variant={page === i + 1 ? "contained" : "outlined"}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </Button>
        ))}
        <Button variant="outlined" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
          Next
        </Button>
      </Box>
    </Wrapper>
  );
};

export default AdminCompanies;

const Wrapper = styled.div`
.StatusToggles{
  button{
    padding: 5px 20px;
  }
  button.Mui-selected{
    background: var(--secondary-color);
    color: white;
  }
}
tbody .compName{
  background: #f2f2f2;
  &:hover a span{
    color: orange;
  }
}
tbody a{
  color: brown;
  &:hover{ color: orange; }
}

`;

